import React from 'react';
import { Button } from '@amzn/atoz-web/Button';
import { useTranslation } from 'react-i18next';
export var ViewDetailsButton = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(Button, { "aria-label": t('shift_management_features_ShiftDetailsModalButtonView_buttonLabel'), "alt-text": t('shift_management_common_button', {
            label: t('shift_management_features_ShiftDetailsModalButtonView_buttonText')
        }), "data-testid": "ViewDetailsButton", onClick: onClick }, t('shift_management_features_ShiftDetailsModalButtonView_buttonText')));
};
